import React from "react";
import { CalendarCheck, PeopleFill, Plus } from "react-bootstrap-icons";
import ViewPendingProducts from "./ViewPendingProducts";

export default function MainPage({ changeMainView, changeRecurring, selectProduct, changeView }) {
  return (
    <div className="container bg-white p-4 mb-5 shadow-sm rounded">
      <p className="fw-bold h3">Payment Options</p>
                <button
        className="floating-back-button"
        onClick={() => changeMainView("classes")}
      >
        ← Back to Classes
      </button>

      <p className="mb-4">
        Please choose one of the two payment models below to begin.
      </p>

      <div className="row g-4">
        <div className="col-md-6">
          <div className="border rounded p-3 h-100 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex align-items-center mb-2">
                <CalendarCheck className="me-2 fs-3 text-primary" />
                <h5 className="mb-0">Flexible Class Pack</h5>
              </div>
              <p className="text-muted">
                Members can buy tokens in advance and use them to book individual classes when they like.
                A token is deducted for each class attended.
              </p>
            </div>
            <button
              className="btn btn-outline-primary mt-3 d-flex align-items-center justify-content-center"
              onClick={() => {
                changeRecurring(false);
                changeView("createProduct");
              }}
            >
              <span className="rounded-circle border border-primary d-flex align-items-center justify-content-center me-2" style={{ width: '28px', height: '28px' }}>
                <Plus className="text-primary" />
              </span>
              Add Flexible Class Pack
            </button>
          </div>
        </div>

        <div className="col-md-6">
          <div className="border rounded p-3 h-100 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex align-items-center mb-2">
                <PeopleFill className="me-2 fs-3 text-primary" />
                <h5 className="mb-0">Subscription</h5>
              </div>
              <p className="text-muted">
                Members pay weekly, monthly, or yearly for unlimited access to all club classes. Best for regulars.
              </p>
            </div>
            <button
              className="btn btn-outline-primary mt-3 d-flex align-items-center justify-content-center"
              onClick={() => {
                changeRecurring(true);
                changeView("createProduct");
              }}
            >
              <span className="rounded-circle border border-primary d-flex align-items-center justify-content-center me-2" style={{ width: '28px', height: '28px' }}>
                <Plus className="text-primary" />
              </span>
              Add Subscription
            </button>
          </div>
        </div>
      </div>

      <hr className="my-4" />

      <ViewPendingProducts selectProduct={selectProduct} />

      <div className="d-flex justify-content-between mt-4">
        <button className="pointer cancelButton fw-bold" onClick={() => changeMainView("classes")}>
          Go Back
        </button>
        <button className="blue-button" onClick={() => changeMainView("review")}>
          Continue
        </button>
      </div>
    </div>
  );
}
